<div class="flex flex-col gap-y-5" *ngIf="!activeUserForm">
  <div *ngIf="user" class="flex justify-between animate-slide-in-left">
    <div class="flex flex-row items-center gap-x-3">
      <div class="flex flex-row items-center gap-x-2 text-dark text-2xl">
        <p>{{ user.full_name || user.name }}</p>
      </div>
    </div>
    <!-- <div class="flex justify-between items-center gap-x-8">
      <div class="flex flex-col gap-y-1" *ngIf="user.current_state">
        <p class="text-xs font-semibold text-dark">ESTADO</p>
        <div class="flex justify-center items-center gap-x-2 text-xs border rounded-xl p-1 w-fit" [style.background-color]="user.current_state.color">
          <span class="text-white text-center">
            {{ user.current_state.name }}
          </span>
        </div>
      </div>
      <div class="flex flex-col gap-y-1">
        <p class="text-xs font-semibold text-dark">ROL</p>
        <p class="text-xs">{{ userRole }}</p>
      </div>
      <div class="flex flex-col gap-y-1" *ngIf="user.created_at">
        <p class="text-xs font-semibold text-dark">CREADO</p>
        <p class="text-xs">{{ user.created_at | date:'dd/MM/yyyy' }}</p>
      </div>
    </div>-->
    <!-- Sin estado global: los estados son por producto (pestaña Productos). -->
    <div class="flex flex-col gap-y-1 items-center">
      <p class="text-xs font-semibold text-center">FECHA</p>
      <p class="text-xs">{{user.created_at | date:'dd/MM/yyyy HH:mm'}}</p>
    </div>
  </div>

  <!-- Selector de carnet general: cambia todo el contenido del alumno por producto -->
  <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-6" *ngIf="user && productStates.length > 0">
    <div class="flex items-center gap-3">
      <button *ngIf="!isTeacherViewing" (click)="toggleActiveProductForm()"
        class="flex items-center justify-center px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg border-2 border-red-600 shadow-md hover:shadow-lg transition-all duration-200 transform hover:scale-105 flex-shrink-0"
        title="Contratar otro producto">
        <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
        </svg>
      </button>
      <div class="flex items-center gap-3 flex-1">
        <div class="w-64">
          <app-custom-dropdown
            [ngModel]="selectedProductId"
            (ngModelChange)="selectProduct($event)"
            [options]="productDropdownOptions"
            [filter]="false"
            [showClear]="false"
            placeholder="Selecciona carnet">
          </app-custom-dropdown>
        </div>
        <span *ngIf="selectedProductState" class="px-2 py-0.5 rounded-full text-xs font-semibold text-white whitespace-nowrap"
          [style.background-color]="selectedProductState.state.color">
          {{ selectedProductState.state.name }}
        </span>
        <!-- Pagar producto: recarga + matricula (solo si esta prematriculado) -->
        <button *ngIf="canMatricular && !isTeacherViewing" (click)="openPayModal()"
          class="ml-auto text-sm px-4 py-2 rounded-lg bg-primary text-white hover:bg-primary-600 whitespace-nowrap">
          Pagar producto
        </button>
      </div>
    </div>
  </div>

  <!-- Modal: pagar producto (recarga monedero + matricula) -->
  <div *ngIf="showPayModal" class="fixed inset-0 z-[300] flex items-center justify-center modal-backdrop p-4" (click)="showPayModal = false">
    <div class="bg-white rounded-2xl shadow-2xl w-full max-w-md" (click)="$event.stopPropagation()">
      <div class="flex items-center justify-between px-6 py-4 border-b border-gray-100">
        <h2 class="text-lg font-bold text-dark">Pagar producto</h2>
        <button (click)="showPayModal = false" class="w-8 h-8 flex items-center justify-center rounded-full text-gray-400 hover:text-white hover:bg-red-500 transition-all">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
        </button>
      </div>
      <div class="px-6 py-5 flex flex-col gap-4">
        <label class="flex flex-col gap-1 text-sm">
          <span class="text-gray-600">Importe a pagar (€)</span>
          <input type="number" min="0" step="0.01" [(ngModel)]="payAmount"
            class="border border-gray-300 rounded-lg px-3 py-2 text-sm" placeholder="0.00" />
        </label>
        <app-payment-method-selector
          [totalAmount]="payAmount"
          (paymentDataChange)="onPayPaymentDataChange($event)">
        </app-payment-method-selector>
        <div class="flex justify-end gap-2">
          <button (click)="showPayModal = false" class="text-sm px-4 py-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50">Cancelar</button>
          <button (click)="confirmPay()" [disabled]="matriculating || !payAmount || payAmount <= 0"
            class="text-sm px-4 py-2 rounded-lg bg-primary text-white hover:bg-primary-600 disabled:opacity-40">
            {{ matriculating ? 'Procesando…' : 'Cobrar y matricular' }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Tabs de navegación -->
  <div class="border-b border-gray-200 mb-6" *ngIf="user">
    <nav class="flex space-x-8" aria-label="Tabs">
      <button (click)="setActiveTab('general')" [class]="activeTab === 'general' 
          ? 'border-primary text-primary' 
          : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
        class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors duration-200">
        Información General
      </button>
      <button *ngIf="isStudent" (click)="setActiveTab('documents')" [class]="activeTab === 'documents'
          ? 'border-primary text-primary'
          : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
        class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors duration-200">
        Documentos
      </button>
      <button (click)="setActiveTab('products')" [class]="activeTab === 'products'
          ? 'border-primary text-primary' 
          : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
        class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors duration-200">
        Progreso
      </button>
      <button *ngIf="isStudent && hasPracticeProgress" (click)="setActiveTab('practice-progress')" [class]="activeTab === 'practice-progress'
          ? 'border-primary text-primary'
          : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
        class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors duration-200">
        Progreso de Práctica
      </button>
      <button *ngIf="isStudent" (click)="setActiveTab('comments')" [class]="activeTab === 'comments'
          ? 'border-primary text-primary'
          : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
        class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors duration-200">
        Comentarios
      </button>
      <button *ngIf="productStates.length > 0 && !isTeacherViewing" (click)="setActiveTab('wallet')" [class]="activeTab === 'wallet'
          ? 'border-primary text-primary'
          : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
        class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors duration-200">
        Monedero
      </button>
      <button (click)="setActiveTab('cards')" [class]="activeTab === 'cards'
          ? 'border-primary text-primary' 
          : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
        class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors duration-200">
        Tarjetas DGT
      </button>
    </nav>
  </div>

  <!-- Contenido de la tab: Productos -->
  <div *ngIf="activeTab === 'products' && user" class="space-y-6">

    <!-- Información del carnet -->
    <div *ngIf="selectedProductState" class="grid grid-cols-1 gap-6">
      <div class="space-y-6">
        <!-- Psicotécnico / Certificado Médico -->
        <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <h3 class="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
            <svg class="w-5 h-5 text-teal-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z" />
            </svg>
            <span>Psicotecnico</span>
          </h3>
          <div *ngIf="loadingPsicotecnico" class="text-sm text-gray-400 text-center py-2">Cargando...</div>
          <div *ngIf="!loadingPsicotecnico && productPsicotecnico" class="space-y-3">
            <div class="p-3 bg-teal-50 rounded-lg border border-teal-200">
              <div class="flex items-center justify-between">
                <div>
                  <div class="font-medium text-sm text-gray-900">{{ productPsicotecnico.media?.[0]?.file_name || 'Psicotecnico' }}</div>
                  <div class="text-xs text-gray-500 mt-0.5">
                    Subido el {{ productPsicotecnico.created_at | date:'dd/MM/yyyy' }}
                    <span *ngIf="productPsicotecnico.expiration_date"> · Caduca: {{ productPsicotecnico.expiration_date | date:'dd/MM/yyyy' }}</span>
                  </div>
                  <div *ngIf="productPsicotecnico.is_expired" class="text-xs text-red-600 font-semibold mt-0.5">Caducado</div>
                  <span class="inline-block text-xs px-2 py-0.5 rounded-full mt-1"
                    [ngClass]="{
                      'bg-yellow-100 text-yellow-700': productPsicotecnico.status === 'pending',
                      'bg-green-100 text-green-700': productPsicotecnico.status === 'accepted',
                      'bg-red-100 text-red-700': productPsicotecnico.status === 'rejected'
                    }">{{ productPsicotecnico.status_label || productPsicotecnico.status }}</span>
                  <div *ngIf="productPsicotecnico.status === 'rejected' && productPsicotecnico.review_feedback"
                    class="text-xs text-red-500 mt-0.5">Motivo: {{ productPsicotecnico.review_feedback }}</div>
                </div>
                <div class="flex gap-1.5">
                  <button *ngIf="productPsicotecnico.status !== 'accepted'" (click)="acceptPsicotecnico()" title="Aceptar"
                    class="p-1.5 text-gray-500 hover:text-green-600 hover:bg-green-50 rounded-lg transition-colors">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                  </button>
                  <button *ngIf="productPsicotecnico.status !== 'rejected'" (click)="rejectPsicotecnico()" title="Rechazar"
                    class="p-1.5 text-gray-500 hover:text-orange-600 hover:bg-orange-50 rounded-lg transition-colors">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                    </svg>
                  </button>
                  <button (click)="downloadPsicotecnico()" title="Descargar"
                    class="p-1.5 text-gray-500 hover:text-teal-600 hover:bg-teal-50 rounded-lg transition-colors">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                    </svg>
                  </button>
                  <button (click)="confirmDeletePsicotecnico()" title="Eliminar"
                    class="p-1.5 text-gray-500 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="!loadingPsicotecnico && !productPsicotecnico">
            <div *ngIf="!uploadingPsicotecnico">
              <p class="text-sm text-gray-500 mb-2">No hay psicotecnico subido para este producto.</p>
              <input type="file" (change)="onPsicotecnicoFileSelected($event)" accept=".pdf,.jpg,.jpeg,.png"
                class="text-sm text-gray-500 file:mr-3 file:py-1.5 file:px-3 file:rounded-lg file:border-0 file:text-sm file:font-medium file:bg-teal-50 file:text-teal-700 hover:file:bg-teal-100 file:cursor-pointer">
            </div>
            <div *ngIf="uploadingPsicotecnico" class="flex items-center gap-2 text-sm text-teal-600 py-2">
              <svg class="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
              </svg>
              Subiendo...
            </div>
          </div>
        </div>

        <!-- Cursos -->
        <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <h3 class="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
            <svg class="w-5 h-5 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M4.26 10.147a60.436 60.436 0 00-.491 6.347A48.627 48.627 0 0112 20.904a48.627 48.627 0 018.232-4.41 60.46 60.46 0 00-.491-6.347m-15.482 0a50.57 50.57 0 00-2.658-.813A59.905 59.905 0 0112 3.493a59.902 59.902 0 0110.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.697 50.697 0 0112 13.489a50.702 50.702 0 017.74-3.342M6.75 15a.75.75 0 100-1.5.75.75 0 000 1.5zm0 0v-3.675A55.378 55.378 0 0112 8.443m-7.007 11.55A5.981 5.981 0 006.75 15.75v-1.5" />
            </svg>
            <span>Cursos</span>
          </h3>
          <div *ngIf="getProductCourses().length > 0" class="space-y-2">
            <div *ngFor="let courseCall of getProductCourses()"
              class="p-3 bg-blue-50 rounded-lg border border-blue-200">
              <div class="font-medium text-sm text-gray-900">{{ courseCall.course?.name }}</div>
              <div class="text-xs text-gray-600 mt-1">
                <span *ngIf="courseCall.start_date">{{ courseCall.start_date | date:'dd/MM/yyyy' }}</span>
                <span *ngIf="courseCall.end_date"> - {{ courseCall.end_date | date:'dd/MM/yyyy' }}</span>
              </div>
            </div>
          </div>
          <p *ngIf="getProductCourses().length === 0" class="text-sm text-gray-500">Sin cursos matriculados</p>
        </div>

        <!-- Exámenes -->
        <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <h3 class="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
            <svg class="w-5 h-5 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
            </svg>
            <span>Exámenes</span>
          </h3>
          <div *ngIf="getProductExams().length > 0" class="space-y-2">
            <div *ngFor="let proof of getProductExams()" class="p-3 bg-green-50 rounded-lg border border-green-200">
              <div class="font-medium text-sm text-gray-900">{{ proof.proofDefinition?.name }}</div>
              <div class="text-xs text-gray-600 mt-1">
                <span *ngIf="proof.date">{{ proof.date | date:'dd/MM/yyyy HH:mm' }}</span>
              </div>
              <div *ngIf="proof.pivot?.result" class="mt-2">
                <span class="px-2 py-1 rounded text-xs font-semibold"
                  [ngClass]="proof.pivot.result === 'APTO' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'">
                  {{ proof.pivot.result }}
                </span>
              </div>
            </div>
          </div>
          <p *ngIf="getProductExams().length === 0" class="text-sm text-gray-500">Sin exámenes convocados</p>
        </div>

        <!-- Tarjetas -->
        <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <h3 class="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
            <svg class="w-5 h-5 text-purple-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5zm6-10.125a1.875 1.875 0 11-3.75 0 1.875 1.875 0 013.75 0zm1.294 6.336a6.721 6.721 0 01-3.17.789 6.721 6.721 0 01-3.168-.789 3.376 3.376 0 016.338 0z" />
            </svg>
            <span>Tarjetas</span>
          </h3>
          <div *ngIf="getProductCards().length > 0" class="space-y-2">
            <div *ngFor="let card of getProductCards()" class="p-3 bg-purple-50 rounded-lg border border-purple-200">
              <div class="font-medium text-sm text-gray-900">{{ card.card_number || 'Tarjeta DGT' }}</div>
              <div class="text-xs text-gray-600 mt-1">
                <span>Tarjeta registrada</span>
              </div>
            </div>
          </div>
          <p *ngIf="getProductCards().length === 0" class="text-sm text-gray-500">Sin tarjetas emitidas</p>
        </div>

        <!-- Pagos -->
        <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <h3 class="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
            <svg class="w-5 h-5 text-amber-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z" />
            </svg>
            <span>Pagos</span>
          </h3>
          <p class="text-sm text-gray-500">Ver en la pestaña "Monedero"</p>
        </div>
      </div>
    </div>

    <!-- Mensaje si no hay productos -->
    <div *ngIf="productStates.length === 0" class="bg-gray-50 border border-gray-200 rounded-lg p-6 text-center">
      <h3 class="text-lg font-semibold text-gray-900 mb-2">Sin productos contratados</h3>
      <p class="text-sm text-gray-600 mb-4">Este usuario aún no tiene productos contratados.</p>
      <button (click)="toggleActiveProductForm()"
        class="px-4 py-2 bg-red-600 hover:bg-red-700 text-white font-medium rounded-lg transition-colors duration-200">
        Contratar Producto
      </button>
    </div>
  </div>

  <!-- Contenido de la tab: Información General -->
  <div *ngIf="activeTab === 'general' && user" class="p-2 md:p-4 space-y-6">
    <!-- Información principal del usuario -->
    <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
      <!-- Información personal - Ocupa 2 columnas -->
      <div class="lg:col-span-2 bg-white rounded-lg shadow-md border border-gray-200 p-3 md:p-6">
        <div class="flex justify-between items-center mb-4">
          <h3 class="text-lg font-semibold text-dark">Información Personal</h3>
          <button (click)="toggleActiveUserForm()"
            class="flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-primary border border-primary rounded-lg hover:bg-primary hover:text-white transition-colors duration-200">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
            </svg>
            Editar
          </button>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <span class="text-sm font-medium text-gray-600">Nombre:</span>
            <p class="text-sm" [ngClass]="user.name ? 'text-dark' : 'text-gray-400 italic'">{{ user.name || '—' }}</p>
          </div>
          <div>
            <span class="text-sm font-medium text-gray-600">Apellidos:</span>
            <p class="text-sm" [ngClass]="user.surname ? 'text-dark' : 'text-gray-400 italic'">{{ user.surname || '—' }}</p>
          </div>
          <div>
            <span class="text-sm font-medium text-gray-600">Email:</span>
            <p class="text-sm" [ngClass]="user.email ? 'text-dark' : 'text-gray-400 italic'">{{ user.email || '—' }}</p>
          </div>
          <div>
            <span class="text-sm font-medium text-gray-600">NIF/DNI:</span>
            <p class="text-sm" [ngClass]="user.nif ? 'text-dark' : 'text-gray-400 italic'">{{ user.nif || '—' }}</p>
          </div>
          <div>
            <span class="text-sm font-medium text-gray-600">Teléfono:</span>
            <p class="text-sm" [ngClass]="user.phone ? 'text-dark' : 'text-gray-400 italic'">{{ user.phone || '—' }}</p>
          </div>
          <div>
            <span class="text-sm font-medium text-gray-600">Calle:</span>
            <p class="text-sm" [ngClass]="user.address ? 'text-dark' : 'text-gray-400 italic'">{{ user.address || '—' }}</p>
          </div>
          <div>
            <span class="text-sm font-medium text-gray-600">Número:</span>
            <p class="text-sm" [ngClass]="user.address_number ? 'text-dark' : 'text-gray-400 italic'">{{ user.address_number || '—' }}</p>
          </div>
          <div>
            <span class="text-sm font-medium text-gray-600">Localidad:</span>
            <p class="text-sm" [ngClass]="user.city ? 'text-dark' : 'text-gray-400 italic'">{{ user.city || '—' }}</p>
          </div>
          <div>
            <span class="text-sm font-medium text-gray-600">Provincia:</span>
            <p class="text-sm" [ngClass]="user.province ? 'text-dark' : 'text-gray-400 italic'">{{ user.province || '—' }}</p>
          </div>
          <div>
            <span class="text-sm font-medium text-gray-600">Código Postal:</span>
            <p class="text-sm" [ngClass]="user.postal_code ? 'text-dark' : 'text-gray-400 italic'">{{ user.postal_code || '—' }}</p>
          </div>
        </div>
      </div>

      <!-- Panel lateral con información del sistema - Más compacto -->
      <div class="space-y-4">
        <!-- Información técnica -->
        <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-3 md:p-4">
          <h4 class="text-sm font-semibold text-gray-700 mb-3">Información técnica</h4>
          <div class="space-y-2">
            <div class="flex items-center justify-between">
              <span class="text-xs text-gray-600">Email:</span>
              <span class="text-xs {{ user.email_verified_at ? 'text-green-600' : 'text-red-600' }}">
                {{ user.email_verified_at ? 'Verificado' : 'Sin verificar' }}
              </span>
            </div>
            <div class="flex items-center justify-between" *ngIf="user.created_at">
              <span class="text-xs text-gray-600">Registro:</span>
              <span class="text-xs text-gray-800">{{ user.created_at | date:'dd/MM/yyyy' }}</span>
            </div>
            <div class="flex items-center justify-between" *ngIf="user.company_id">
              <span class="text-xs text-gray-600">Empresa:</span>
              <span class="text-xs text-gray-800">#{{ user.company_id }}</span>
            </div>
            <div class="flex items-center justify-between" *ngIf="user.updated_at">
              <span class="text-xs text-gray-600">Última actualización:</span>
              <span class="text-xs text-gray-800">{{ user.updated_at | date:'dd/MM/yyyy HH:mm' }}</span>
            </div>
            <div class="flex items-center justify-between" *ngIf="user.email_verified_at">
              <span class="text-xs text-gray-600">Email verificado:</span>
              <span class="text-xs text-gray-800">{{ user.email_verified_at | date:'dd/MM/yyyy HH:mm' }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Cursos -->
    <div class="bg-white rounded-lg shadow-md border border-gray-200 p-3 md:p-6 mb-6"
      *ngIf="user.course_calls.length > 0">
      <div class="flex justify-between items-center mb-4">
        <h3 class="text-lg font-semibold text-dark">Convocatorias de Cursos</h3>
      </div>
      <div class="space-y-4">
        <div *ngFor="let coursecall of user.course_calls" class="border border-gray-100 rounded-lg p-4 bg-gray-50">
          <div class="flex items-center justify-between mb-2">
            <h4 class="font-medium text-dark">{{ coursecall.course?.name || 'Curso' }}</h4>
            <div *ngIf="coursecall.current_state_record?.state"
              class="flex justify-center items-center gap-x-2 text-xs border rounded-xl p-1 pl-3 pr-3 w-fit"
              [style.background-color]="coursecall.current_state_record.state.color">
              <span class="text-white text-center">{{ coursecall.current_state_record.state.name}}</span>
            </div>
          </div>
          <div class="grid grid-cols-2 gap-4 text-sm text-gray-600">
            <div>
              <span class="font-medium">Sucursal:</span> {{ coursecall.office?.name || 'N/A' }}
            </div>
            <div>
              <span class="font-medium">Fecha inicio:</span> {{ coursecall.start_date | date:'dd/MM/yyyy' }}
            </div>
            <div>
              <span class="font-medium">Fecha fin:</span> {{ coursecall.end_date | date:'dd/MM/yyyy' }}
            </div>
            <div>
              <span class="font-medium">Límite inscripción:</span> {{ coursecall.registration_deadline |
              date:'dd/MM/yyyy' }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Exámenes -->
    <div class="bg-white rounded-lg shadow-md border border-gray-200 p-3 md:p-6 mb-6" *ngIf="user.proofs.length > 0">
      <div class="flex justify-between items-center mb-4">
        <h3 class="text-lg font-semibold text-dark">Exámenes</h3>
      </div>
      <div class="space-y-4">
        <div *ngFor="let proof of user.proofs" class="border border-gray-100 rounded-lg p-4 bg-gray-50">
          <div class="flex items-center justify-between mb-2">
            <h4 class="font-medium text-dark">{{ proof.generated_name || proof.proof_definitions_names || 'Examen' }}</h4>
            <div *ngIf="proof.current_state"
              class="flex justify-center items-center gap-x-2 text-xs border rounded-xl p-1 pl-3 pr-3 min-w-24"
              [style.background-color]="proof.current_state.color">
              <span class="text-white text-center">{{ proof.current_state.name }}</span>
            </div>
          </div>
          <div class="grid grid-cols-2 gap-4 text-sm text-gray-600">
            <div>
              <span *ngIf="proof.date" class="font-medium">Fecha del examen:</span> {{ proof.date | date:'dd/MM/yyyy' }}
            </div>
            <div>
              <span *ngIf="proof.date_time" class="font-medium">Hora del examen:</span> {{ proof.date_time |
              date:'HH:mm' }}
            </div>
            <div>
              <span *ngIf="proof.proof_center" class="font-medium">Centro:</span> {{ proof.proof_center?.name || 'Por
              asignar' }}
            </div>

            <!-- Hora de cita y/o Calificación en la misma línea -->
            <div class="col-span-2 flex items-center"
              [ngClass]="proof.pivot?.appointment_date_time_site ? 'justify-between' : 'justify-end'">
              <!-- Hora de cita (si existe) -->
              <div *ngIf="proof.pivot?.appointment_date_time_site"
                class="bg-green-100 border-l-4 border-green-500 p-3 rounded-r-lg">
                <div class="flex items-center">
                  <svg class="w-4 h-4 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                      clip-rule="evenodd"></path>
                  </svg>
                  <span class="font-semibold text-green-800">Hora de Cita:</span>
                  <span class="ml-2 font-bold text-green-900">{{ proof.pivot.appointment_date_time_site | date:'HH:mm'
                    }}</span>
                </div>
              </div>

              <!-- Calificación (siempre visible si existe, en la misma posición) -->
              <div *ngIf="proof.qualification_name">
                <div class="px-4 py-2 text-white font-extrabold text-center rounded-lg shadow-lg w-24"
                  [style.background]="
                       proof.qualification_name?.toUpperCase().includes('APTO') && !proof.qualification_name?.toUpperCase().includes('NO') 
                         ? '#10B981' 
                         : proof.qualification_name?.toUpperCase().includes('NO')
                         ? '#EF4444'
                         : '#6B7280'
                     ">
                  {{ proof.qualification_name }}
                </div>
                <div *ngIf="!proof.qualification_name"
                  class="px-4 py-2 text-white font-extrabold text-center rounded-lg shadow-lg w-24 min-w-24 bg-gray-500">
                  Pendiente
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Contratos -->
    <div *ngIf="getProductContracts().length > 0" class="bg-white rounded-lg shadow-md border border-gray-200 p-3 md:p-6">
      <div class="flex justify-between items-center mb-4">
        <h3 class="text-lg font-semibold text-dark">Contratos</h3>
        <div class="flex items-center gap-2">
          <span class="text-sm text-gray-500">{{ getProductContracts().length }} contrato(s)</span>
        </div>
      </div>

      <div *ngIf="loadingContracts" class="flex justify-center items-center py-8">
        <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-red-600"></div>
        <span class="ml-2 text-gray-500">Cargando contratos...</span>
      </div>

      <div class="space-y-4" *ngIf="!loadingContracts">
        <div *ngFor="let contract of getProductContracts()" (click)="viewContractPdf(contract)"
          class="border border-gray-100 rounded-lg p-4 bg-gray-50 hover:bg-gray-100 transition-colors cursor-pointer">
          <div class="flex items-center justify-between">
            <div>
              <h4 class="font-medium text-dark">{{ contract.template?.name || 'Contrato' }}</h4>
              <p class="text-sm text-gray-500 mt-1">
                {{ contract.product?.name }}
              </p>
            </div>
            <div class="flex flex-col items-end gap-2">
              <span class="px-2 py-0.5 rounded-full text-xs font-semibold text-white"
                [ngClass]="{
                  'bg-green-600': contract.acceptance_status === 'accepted',
                  'bg-red-600': contract.acceptance_status === 'rejected',
                  'bg-amber-500': !contract.acceptance_status || contract.acceptance_status === 'pending'
                }">
                {{ contract.acceptance_status === 'accepted' ? 'Aceptado'
                   : contract.acceptance_status === 'rejected' ? 'Rechazado' : 'Pendiente' }}
              </span>
              <p class="text-sm text-gray-500">{{ contract.created_at | date:'dd/MM/yyyy' }}</p>
              <button (click)="resendContract(contract); $event.stopPropagation()"
                class="text-xs text-primary hover:underline">
                Reenviar por email
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Contenido de la tab Tarjetas DGT -->
  <div *ngIf="activeTab === 'cards'" class="animate-fade-in">
    <div class="bg-white rounded-lg shadow-md border border-gray-200 p-6">
      <h3 class="text-lg font-semibold text-dark mb-6">Tarjetas DGT</h3>

      <!-- Bulk actions -->
      <div *ngIf="!isLoadingCards && getProductCards().length > 0" class="mb-6">
        <div class="flex flex-wrap items-center gap-3 mb-4">
          <div class="flex items-center gap-x-2">
            <input type="checkbox" [checked]="allSelected" (change)="toggleSelectAll()"
              class="w-5 h-5 text-primary border-gray-300 rounded focus:ring-primary" />
            <span class="text-sm text-gray-600">
              {{ selectedCards.size > 0 ? selectedCards.size + ' seleccionada(s)' : 'Seleccionar todas' }}
            </span>
          </div>

          <div *ngIf="selectedCards.size > 0" class="flex flex-wrap gap-2">
            <button (click)="bulkRequestCards()" [disabled]="isUpdatingStatus"
              class="px-4 py-2 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors duration-200 flex items-center gap-x-2">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="7 10 12 15 17 10"></polyline>
                <line x1="12" y1="15" x2="12" y2="3"></line>
              </svg>
              <span>{{ isUpdatingStatus ? 'Procesando...' : 'Solicitar a DGT' }}</span>
            </button>

            <button (click)="bulkMarkAsReceived()" [disabled]="isUpdatingStatus"
              class="px-4 py-2 text-sm bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors duration-200 flex items-center gap-x-2">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
              <span>{{ isUpdatingStatus ? 'Procesando...' : 'Marcar Recibidas' }}</span>
            </button>

            <button (click)="bulkMarkAsDelivered()" [disabled]="isUpdatingStatus"
              class="px-4 py-2 text-sm bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors duration-200 flex items-center gap-x-2">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
              <span>{{ isUpdatingStatus ? 'Procesando...' : 'Marcar Entregadas' }}</span>
            </button>
          </div>
        </div>
      </div>

      <div *ngIf="isLoadingCards" class="flex justify-center items-center py-12">
        <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>

      <div *ngIf="!isLoadingCards && getProductCards().length === 0" class="text-center py-12">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-16 h-16 mx-auto text-gray-300 mb-4" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="2">
          <rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
          <line x1="1" y1="10" x2="23" y2="10"></line>
        </svg>
        <p class="text-gray-500 text-lg mb-2">No hay tarjetas generadas</p>
        <p class="text-gray-400 text-sm">Las tarjetas aparecerán aquí cuando se completen los exámenes necesarios para
          completar un carnet</p>
      </div>

      <!-- Grid de tarjetas -->
      <div *ngIf="!isLoadingCards && getProductCards().length > 0" class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <div *ngFor="let card of getProductCards()" (click)="toggleCardSelection(card.id)" [class]="selectedCards.has(card.id) 
            ? 'border-2 border-primary bg-blue-50' 
            : 'border border-gray-200 hover:border-primary hover:shadow-md'"
          class="rounded-lg p-4 cursor-pointer transition-all duration-200">
          <!-- Checkbox y permiso -->
          <div class="mb-3">
            <div class="flex items-center justify-between mb-2">
              <div class="flex items-center gap-x-3">
                <input type="checkbox" [checked]="selectedCards.has(card.id)" (click)="$event.stopPropagation()"
                  (change)="toggleCardSelection(card.id)"
                  class="w-5 h-5 text-primary border-gray-300 rounded focus:ring-primary" />
                <h4 class="font-semibold text-dark text-lg">Permiso {{ card.license?.name }}</h4>
              </div>
              <span *ngIf="card.card_number" class="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded">
                #{{ card.card_number }}
              </span>
            </div>
          </div>

          <!-- Estado actual -->
          <div class="flex items-center justify-center text-xs rounded-lg p-2 mb-3"
            [style.background-color]="card.current_state?.color || '#gray'">
            <span class="text-white font-medium">{{ card.current_state?.name || 'Sin estado' }}</span>
          </div>

          <!-- Información adicional -->
          <div class="space-y-2 text-xs text-gray-600">
            <div class="flex items-center gap-x-2" *ngIf="card.qualification?.name">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-green-600" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                <polyline points="22 4 12 14.01 9 11.01"></polyline>
              </svg>
              <span>Calificación: <strong>{{ card.qualification?.name }}</strong></span>
            </div>

            <div class="flex items-center gap-x-2" *ngIf="card.approved_date">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"></circle>
                <polyline points="12 6 12 12 16 14"></polyline>
              </svg>
              <span>Aprobado: {{ card.approved_date | date:'dd/MM/yyyy' }}</span>
            </div>

            <div class="flex items-center gap-x-2" *ngIf="card.requested_date">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-blue-600" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="7 10 12 15 17 10"></polyline>
                <line x1="12" y1="15" x2="12" y2="3"></line>
              </svg>
              <span class="text-blue-600">Solicitada: {{ card.requested_date | date:'dd/MM/yyyy' }}</span>
            </div>

            <div class="flex items-center gap-x-2" *ngIf="card.received_date">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-purple-600" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
              <span class="text-purple-600">Recibida: {{ card.received_date | date:'dd/MM/yyyy' }}</span>
            </div>

            <div class="flex items-center gap-x-2" *ngIf="card.delivered_date">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-green-600" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
              <span class="text-green-600">Entregada: {{ card.delivered_date | date:'dd/MM/yyyy' }}</span>
            </div>

            <div class="flex items-center gap-x-2" *ngIf="card.expiration_date">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-orange-600" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
              </svg>
              <span class="text-orange-600">Caduca: {{ card.expiration_date | date:'dd/MM/yyyy' }}</span>
            </div>

            <div *ngIf="card.observations" class="mt-3 p-2 bg-gray-50 rounded text-xs">
              <span class="font-medium">Observaciones:</span>
              <p class="mt-1">{{ card.observations }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Contenido de la tab Wallet -->
  <div *ngIf="activeTab === 'wallet' && productStates.length > 0" class="animate-fade-in">
    <app-user-wallet *ngIf="user" [userId]="user.id" [productStates]="productStates" [activeProductId]="selectedProductId"></app-user-wallet>
  </div>

  <!-- Contenido de la tab Comentarios -->
  <div *ngIf="activeTab === 'comments' && isStudent" class="animate-fade-in">
    <app-student-comments-list *ngIf="user" [studentId]="user.id" [productId]="selectedProductId"></app-student-comments-list>
  </div>

  <!-- Contenido de la tab Progreso de Práctica -->
  <div *ngIf="activeTab === 'practice-progress' && isStudent" class="animate-fade-in">
    <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
      <div class="mb-6">
        <h2 class="text-xl font-bold text-gray-900">Evaluaciones de Habilidades de Práctica</h2>
        <p class="text-sm text-gray-600 mt-1">Visualiza el progreso del alumno en las diferentes habilidades evaluadas durante las prácticas</p>
      </div>
      <app-student-skills-progress *ngIf="user" [studentId]="user.id" (openHistoryModal)="openSkillHistoryModal($event)"></app-student-skills-progress>
    </div>
  </div>

  <!-- Contenido de la tab Documentos -->
  <div *ngIf="activeTab === 'documents' && isStudent" class="animate-fade-in">
    <app-student-documents-tab 
      #documentsTab 
      *ngIf="user" 
      [userId]="user.id" 
      [user]="user" 
      (userUpdated)="onUserDocumentsUpdated()"
      (openDocumentModal)="onOpenDocumentModal($event)"
      (closeDocumentModal)="onCloseDocumentModal()"
      (openConfirmation)="onOpenConfirmation($event)">
    </app-student-documents-tab>
  </div>
</div>

<!-- Modal de comentarios (fuera del contexto animate-fade-in) -->
<div *ngIf="showCommentsModal"
  (click)="closeCommentsModal()"
  class="fixed animate-fade-in inset-0 z-50 flex items-center justify-center modal-backdrop p-4 overflow-y-auto">
  <div (click)="$event.stopPropagation()" [ngClass]="'max-w-'+commentsListComponent.currentGenericForm!.width"
    class="bg-white relative rounded-3xl shadow-2xl w-full my-8 animate-slide-in-top">
    <!-- Header del modal -->
    <div class="flex items-center justify-between px-8 py-6 border-b border-gray-100">
      <h2 class="text-2xl font-bold text-gray-800">{{ commentsListComponent.currentGenericForm!.formTitle }}</h2>
      <button (click)="closeCommentsModal()"
        class="w-10 h-10 flex items-center justify-center rounded-full text-gray-400 hover:text-white hover:bg-red-500 transition-all duration-200">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>
    <!-- Contenido del modal -->
    <div class="px-8 py-6">
      <app-generic-form
        [genericForm]="commentsListComponent.currentGenericForm!"
        [selectedItem]="commentsListComponent.genericFormInitialData"
        [showCancel]="true"
        (onCancel)="closeCommentsModal()"
        (onFinished)="onCommentsFormSuccess()">
      </app-generic-form>
    </div>
  </div>
</div>

<!-- Modal Wallet (fuera del contexto animate-fade-in) -->
<div *ngIf="showWalletModal"
  (click)="closeWalletModal()"
  class="fixed animate-fade-in inset-0 z-50 flex items-center justify-center modal-backdrop p-4 overflow-y-auto">
  <div (click)="$event.stopPropagation()" [ngClass]="'max-w-'+walletComponent.currentGenericForm!.width"
    class="bg-white relative rounded-3xl shadow-2xl w-full my-8 animate-slide-in-top">
    <!-- Header del modal -->
    <div class="flex items-center justify-between px-8 py-6 border-b border-gray-100">
      <h2 class="text-2xl font-bold text-gray-800">{{ walletComponent.currentGenericForm!.formTitle }}</h2>
      <button (click)="closeWalletModal()"
        class="w-10 h-10 flex items-center justify-center rounded-full text-gray-400 hover:text-white hover:bg-red-500 transition-all duration-200">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>
    <!-- Contenido del modal -->
    <div class="px-8 py-6">
      <app-generic-form
        [genericForm]="walletComponent.currentGenericForm!"
        [selectedItem]="walletComponent.genericFormInitialData"
        [showCancel]="true"
        (onCancel)="closeWalletModal()"
        (onFinished)="onWalletFormSuccess()">
      </app-generic-form>
    </div>
  </div>
</div>

<!-- Modal Wallet Recarga Custom -->
<app-modal *ngIf="showWalletRechargeModal"
  title="Recargar Saldo"
  [fullscreen]="true"
  (close)="closeWalletRechargeModal()">
  <div class="space-y-5 max-w-2xl mx-auto">

    <!-- Monto -->
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-2">Monto (€) *</label>
      <input type="number" [(ngModel)]="walletComponent.rechargeFormData.amount"
        min="0.01" step="0.01"
        class="w-full border border-gray-300 rounded-xl px-4 py-3 text-gray-800 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
        placeholder="0.00">
    </div>

    <!-- Origen de fondos (solo si hay opciones de transferencia) -->
    <div *ngIf="walletComponent.rechargePaymentOptions.length > 1">
      <label class="block text-sm font-medium text-gray-700 mb-2">Origen de Fondos *</label>
      <p-dropdown
        [(ngModel)]="walletComponent.rechargeFormData.payment_method"
        [options]="walletComponent.rechargePaymentOptions"
        optionLabel="name"
        optionValue="id"
        placeholder="Selecciona origen..."
        variant="filled"
        appendTo="body"
        styleClass="w-full">
      </p-dropdown>
    </div>

    <!-- Método de pago (solo si pago externo) -->
    <app-payment-method-selector
      *ngIf="walletComponent.isExternalPayment"
      [totalAmount]="walletComponent.rechargeFormData.amount"
      (paymentDataChange)="walletComponent.onRechargePaymentDataChange($event)">
    </app-payment-method-selector>

    <!-- Error -->
    <div *ngIf="walletComponent.rechargeError" class="bg-red-50 border border-red-200 rounded-xl px-4 py-3 text-red-700 text-sm">
      {{ walletComponent.rechargeError }}
    </div>

    <!-- Botón submit -->
    <div class="flex justify-end pt-2">
      <button (click)="walletComponent.submitRechargeForm()"
        [disabled]="!walletComponent.isRechargeFormValid() || walletComponent.rechargeSubmitting"
        class="px-6 py-3 bg-primary text-white rounded-xl font-semibold transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed hover:opacity-90 flex items-center gap-2">
        <svg *ngIf="walletComponent.rechargeSubmitting" class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 12 20.59 12 12H4z"></path>
        </svg>
        <span>{{ walletComponent.rechargeSubmitting ? 'Procesando...' : 'Confirmar' }}</span>
      </button>
    </div>

  </div>
</app-modal>

<!-- Modal producto -->
<app-modal *ngIf="activeProductForm"
  title="Contratar Producto"
  [fullscreen]="true"
  (close)="toggleActiveProductForm()">
  <div class="space-y-5 max-w-2xl mx-auto">

      <!-- Loading state -->
      <div *ngIf="productFormLoading" class="flex items-center justify-center py-10">
        <div class="animate-spin w-8 h-8 border-4 border-primary border-t-transparent rounded-full"></div>
      </div>

      <ng-container *ngIf="!productFormLoading">

        <!-- Selector de producto -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-2">Producto *</label>
          <p-dropdown
            [(ngModel)]="productFormData.product_id"
            (ngModelChange)="onProductSelected()"
            [options]="productsList"
            optionLabel="name"
            optionValue="id"
            placeholder="Selecciona un producto..."
            variant="filled"
            [filter]="true"
            filterBy="name"
            appendTo="body"
            styleClass="w-full">
          </p-dropdown>
        </div>

        <!-- Precio del producto seleccionado -->
        <div *ngIf="selectedProductForForm" class="bg-blue-50 border border-blue-100 rounded-2xl p-4 flex items-center justify-between">
          <div>
            <p class="text-xs text-blue-500 font-semibold uppercase tracking-wide mb-1">Precio total del producto</p>
            <p class="text-3xl font-bold text-blue-800">{{ selectedProductForForm.total_price | number:'1.2-2' }} €</p>
          </div>
          <svg class="w-12 h-12 text-blue-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2z"></path>
          </svg>
        </div>

        <!-- Selector de método de pago -->
        <app-payment-method-selector
          [totalAmount]="selectedProductForForm?.total_price"
          (paymentDataChange)="onPaymentDataChange($event)">
        </app-payment-method-selector>

        <!-- Importe pagado ahora (pago simple): define si queda prematriculado o matriculado -->
        <div *ngIf="productFormData.payment_method !== 'split'" class="flex flex-col gap-1">
          <label class="text-sm font-semibold text-gray-700">Importe pagado ahora (€)</label>
          <input type="number" min="0" step="0.01" [(ngModel)]="productFormData.paid_amount"
            class="border border-gray-300 rounded-lg px-3 py-2 w-48 focus:outline-none focus:ring-2 focus:ring-primary/40"
            placeholder="0.00">
          <p class="text-xs text-gray-500">Con saldo &gt; 0 el alumno queda matriculado; sin pago, prematriculado.</p>
        </div>

        <!-- Error -->
        <div *ngIf="productFormError" class="bg-red-50 border border-red-200 rounded-xl px-4 py-3 text-red-700 text-sm">
          {{ productFormError }}
        </div>

        <!-- Botón submit -->
        <div class="flex justify-end pt-2">
          <button (click)="submitProductForm()"
            [disabled]="!isProductFormValid() || productFormSubmitting"
            class="px-6 py-3 bg-primary text-white rounded-xl font-semibold transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed hover:opacity-90 flex items-center gap-2">
            <svg *ngIf="productFormSubmitting" class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 12 20.59 12 12H4z"></path>
            </svg>
            <span>{{ productFormSubmitting ? 'Procesando...' : 'Contratar Producto' }}</span>
          </button>
        </div>

      </ng-container>
  </div>
</app-modal>

<!-- User Form -->
<app-modal *ngIf="activeUserForm && genericForm"
  [title]="genericForm.formTitle"
  [fullscreen]="true"
  (close)="toggleActiveUserForm()">
  <app-generic-form (onFinished)="onFinishUserForm()" (onCancel)="toggleActiveUserForm()" [showCancel]="true" [genericForm]="genericForm" [selectedItem]="user">
  </app-generic-form>
</app-modal>

<!-- Modal para visualizar PDF del contrato -->
<div *ngIf="showContractPdf"
  (click)="closeContractPdf()"
  class="fixed animate-fade-in inset-0 z-50 flex items-center justify-center modal-backdrop p-4">
  <div (click)="$event.stopPropagation()" class="relative w-full h-full max-w-6xl max-h-screen bg-white rounded-3xl shadow-2xl flex flex-col animate-slide-in-top">
    <!-- Header del modal -->
    <div class="flex items-center justify-between px-8 py-6 border-b border-gray-100">
      <div class="flex items-center gap-3">
        <h2 class="text-2xl font-bold text-gray-800">
          {{ selectedContract?.template?.name }}
        </h2>
        <span class="text-sm text-gray-500">
          {{ selectedContract?.contract_number }}
        </span>
      </div>
      <button (click)="closeContractPdf()"
        class="w-10 h-10 flex items-center justify-center rounded-full text-gray-400 hover:text-white hover:bg-red-500 transition-all duration-200">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>

    <!-- Visor PDF -->
    <div class="flex-1 p-4" style="height: 100%;">
      <pdf-viewer *ngIf="contractPdfSrc" [src]="contractPdfSrc" [render-text]="true" [show-all]="true"
        style="display: block; width: 100%; height: 100%;"></pdf-viewer>

      <!-- Loading state -->
      <div *ngIf="!contractPdfSrc" class="flex items-center justify-center h-full">
        <div class="text-center">
          <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-red-600 mx-auto mb-4"></div>
          <p class="text-gray-500">Cargando contrato...</p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal de historial de habilidades de práctica -->
<div *ngIf="showSkillHistoryModal && selectedSkillHistory"
  (click)="closeSkillHistoryModal()"
  class="fixed animate-fade-in inset-0 z-50 flex items-center justify-center modal-backdrop p-4 overflow-y-auto">
  <div (click)="$event.stopPropagation()"
    class="bg-white relative rounded-3xl shadow-2xl w-full max-w-2xl max-h-[85vh] overflow-hidden animate-slide-in-top">
    <!-- Header del modal -->
    <div class="flex items-center justify-between px-8 py-6 border-b border-gray-100">
      <div>
        <h2 class="text-2xl font-bold text-gray-800">Historial de Habilidad</h2>
        <p class="text-gray-600 text-sm mt-1">{{ selectedSkillHistory.skill.name }}</p>
      </div>
      <button (click)="closeSkillHistoryModal()"
        class="w-10 h-10 flex items-center justify-center rounded-full text-gray-400 hover:text-white hover:bg-red-500 transition-all duration-200">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>

    <!-- Contenido del modal -->
    <div class="px-8 py-6 overflow-y-auto max-h-[calc(85vh-140px)]">
      <div class="space-y-4">
        <div *ngFor="let evaluation of selectedSkillHistory.evaluations; let i = index"
          class="bg-gray-50 rounded-xl p-5 border border-gray-200 hover:border-gray-300 hover:shadow-sm transition-all duration-300">
          <div class="flex items-start justify-between mb-3">
            <span
              class="inline-flex items-center px-4 py-1.5 rounded-full text-sm font-bold border-2 shadow-sm"
              [ngClass]="getRatingColor(evaluation.rating)">
              <span class="text-base mr-1.5">{{ getRatingEmoji(evaluation.rating) }}</span>
              {{ getRatingLabel(evaluation.rating) }}
            </span>
            <span class="text-xs text-gray-600 font-medium px-3 py-1 bg-white rounded-full border border-gray-200">
              {{ formatHistoryDate(evaluation.evaluated_at) }}
            </span>
          </div>

          <div *ngIf="evaluation.student_comment?.comment" class="mt-4 bg-white rounded-lg p-4 border border-gray-200">
            <p class="text-sm text-gray-700 leading-relaxed">{{ evaluation.student_comment.comment }}</p>
          </div>

          <div class="mt-3 flex items-center text-xs text-gray-600">
            <svg class="w-4 h-4 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
            <span class="font-medium">{{ evaluation.teacher?.name || 'Profesor' }}</span>
          </div>
        </div>

        <!-- Empty history state -->
        <div *ngIf="!selectedSkillHistory.evaluations || selectedSkillHistory.evaluations.length === 0" class="text-center py-12">
          <svg class="mx-auto h-16 w-16 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <p class="mt-4 text-sm text-gray-600 font-medium">No hay evaluaciones registradas para esta habilidad</p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal de documentos (fuera del contexto animate-fade-in) -->
<div *ngIf="showDocumentModal && documentsTab"
  (click)="onCloseDocumentModal()"
  class="fixed animate-fade-in inset-0 z-50 flex items-center justify-center modal-backdrop p-4 overflow-y-auto">
  <div (click)="$event.stopPropagation()"
    class="bg-white relative rounded-3xl shadow-2xl w-full max-w-lg my-8 animate-slide-in-top">
    <!-- Header del modal -->
    <div class="flex items-center justify-between px-8 py-6 border-b border-gray-100">
      <h2 class="text-2xl font-bold text-gray-800">
        {{ documentModalData?.isEditing ? 'Editar Documento' : 'Nuevo Documento' }}
      </h2>
      <button (click)="onCloseDocumentModal()"
        class="w-10 h-10 flex items-center justify-center rounded-full text-gray-400 hover:text-white hover:bg-red-500 transition-all duration-200">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>
    <!-- Contenido del modal -->
    <div class="px-8 py-6 space-y-4">
      <!-- Tipo de documento -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">
          Tipo de Documento <span class="text-red-500">*</span>
        </label>
        <app-custom-dropdown
          [(ngModel)]="documentsTab.documentsListComponent.formData.document_type"
          [options]="documentsTab.documentsListComponent.documentTypes"
          placeholder="Seleccionar..."
          [showClear]="false">
        </app-custom-dropdown>
      </div>

      <!-- Archivo (solo en crear) -->
      <div *ngIf="!documentModalData?.isEditing">
        <label class="block text-sm font-medium text-gray-700 mb-1">
          Archivo <span class="text-red-500">*</span>
        </label>
        <input
          type="file"
          accept="image/*,application/pdf"
          (change)="documentsTab.documentsListComponent.onFileSelected($event)"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-green-500 focus:border-green-500"
        />
        <p class="text-xs text-gray-500 mt-1">Formatos: JPG, PNG, PDF. Maximo 10MB.</p>
      </div>

      <!-- Fecha de expiracion -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">
          Fecha de Expiracion (opcional)
        </label>
        <input
          type="date"
          [(ngModel)]="documentsTab.documentsListComponent.formData.expiration_date"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-green-500 focus:border-green-500"
        />
      </div>

      <!-- Notas -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">
          Notas (opcional)
        </label>
        <textarea
          [(ngModel)]="documentsTab.documentsListComponent.formData.notes"
          rows="3"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2"
          placeholder="Observaciones sobre el documento..."></textarea>
      </div>

      <!-- Footer con botones -->
      <div class="flex justify-end gap-3 pt-4 border-t border-gray-200">
        <button
          (click)="onCloseDocumentModal()"
          class="px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 transition-colors duration-200">
          Cancelar
        </button>
        <button
          (click)="documentsTab.documentsListComponent.saveDocument()"
          [disabled]="documentsTab.documentsListComponent.loading"
          class="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200 flex items-center gap-2">
          <svg *ngIf="documentsTab.documentsListComponent.loading" class="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          {{ documentsTab.documentsListComponent.loading ? 'Guardando...' : (documentModalData?.isEditing ? 'Actualizar' : 'Guardar') }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal de confirmación (fuera del contexto animate-fade-in) -->
<app-confirmation
  *ngIf="showConfirmationModal"
  [visible]="showConfirmationModal"
  [question]="confirmationQuestion"
  confirmText="Confirmar"
  cancelText="Cancelar"
  (confirm)="handleConfirmAction()"
  (cancel)="handleCancelAction()">
</app-confirmation>

<app-reject-reason-modal
  [visible]="showRejectPsicoModal"
  title="Rechazar psicotécnico"
  (confirm)="confirmRejectPsicotecnico($event)"
  (cancel)="showRejectPsicoModal = false">
</app-reject-reason-modal>